import React from 'react'
import {Tabs,Container,Form,Col} from 'react-bootstrap'
import {CustomDrop, YesNoDrop,CustomDropWithExtras} from "../../demographics/dropdowns/components"
import Title from "../../../utilities/other/title"
function Diagnosis(props){
    const handleChange = (event) =>{
        props.handler("diagnosis",event)
    }
    return(
        <Container fluid>
            <Title>Diagnosis</Title>
            <br/>
            <Form>
             <Form.Row>
                <YesNoDrop title="Unclassified Parkinsonism" val={props.data!=null? props.data:null} disabled ={props.disabled} name={"unclassified_parkinsonism"} handler={handleChange}/>
                
                <CustomDrop title="Parkinson’s disease" val={props.data!=null? props.data:null} disabled ={props.disabled} name={"parkinsons_disease"} handler={handleChange} options={["","Clinically established","Probable"]}/>
              
               
                <CustomDrop title="Progressive supranuclear palsy" val={props.data!=null? props.data:null} disabled ={props.disabled} name={"progressive_supranuclear_palsy"} handler={handleChange} options={["","Probable","Possible","Suggestive of"]}/>
                <CustomDrop title="Multiple System Atrophy" val={props.data!=null? props.data:null} disabled ={props.disabled} name={"multiple_system_atrophy"} handler={handleChange} options={["","Clinically established","Clinically Probable","Possible prodomal",]}/>

               
                </Form.Row>
                <Title>Genetic Testing</Title>
                <Form.Row>
                    {/* <CustomDrop title="Genetic Testing" val={props.data!=null? props.data:null} disabled ={props.disabled} name={"progressive_supranuclear_palsy"} handler={handleChange} options={["","Probable","Possible","Suggestive of"]}/> */}
                    
                    <CustomDropWithExtras
                    val={props.data!=null? props.data:null} disabled ={props.disabled}
                name="genetic_testing"
                title="Genetic Testing"
                options={[' ','Yes', 'No']}
                triggerValue="Yes"
                dateName="genetic_testing_date"
                dateLabel="When"
                text1Name="genetic_testing_gene"
                text1Label="Gene"
                text2Name="genetic_testing_mutation"
                text2Label="Mutation"
                handler={handleChange}
            />
                </Form.Row>
            </Form>
        </Container>
    )
}

export default Diagnosis;